@if (active) {
  <div @toggleHeight class="flex items-center rounded-md">
    <ng-content />
  </div>
}
